var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmedNotstarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33 32.6104V36.9992C33 38.0601 32.5786 39.0775 31.8284 39.8277C31.0783 40.5778 30.0609 40.9992 29 40.9992H5C3.93913 40.9992 2.92172 40.5778 2.17157 39.8277C1.42143 39.0775 1 38.0601 1 36.9992V32.6104H33Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 5.00586H29C30.0609 5.00586 31.0783 5.42729 31.8284 6.17743C32.5786 6.92758 33 7.94499 33 9.00586V37.0059C33 38.0667 32.5786 39.0841 31.8284 39.8343C31.0783 40.5844 30.0609 41.0059 29 41.0059H5C3.93913 41.0059 2.92172 40.5844 2.17157 39.8343C1.42143 39.0841 1 38.0667 1 37.0059V9.00586C1 7.94499 1.42143 6.92758 2.17157 6.17743C2.92172 5.42729 3.93913 5.00586 5 5.00586H9",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23 1.00195H11C9.89543 1.00195 9 1.89738 9 3.00195V7.00195C9 8.10652 9.89543 9.00195 11 9.00195H23C24.1046 9.00195 25 8.10652 25 7.00195V3.00195C25 1.89738 24.1046 1.00195 23 1.00195Z",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250847",
    d: "M13.7324 22.7381L16.1324 25.3307L21.1991 20.6641",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1025",
    cx: 17,
    cy: 22.998,
    r: 7,
    stroke: "#383434",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedNotstarted);
export default __webpack_public_path__ + "static/media/confirmed_notstarted.882b757575ed48630ee5c3e515aeb38b.svg";
export { ForwardRef as ReactComponent };